<template>
  <v-form ref="NewsletterForm">
    <div  class="mt-4 secondary--text text--lighten-2 ">
        {{ $t("newsletter_form/intro_text") }}
    </div>
    <v-layout justify-center row wrap class="pb-2">
      <v-flex xs10 sm10 md8 text-xs-center>
        <v-text-field
          v-model="form.email"
          :placeholder="$t('support_form/email')"
          :rules="[rules.required, rules.email]"
          color="secondary"
          append-icon="mail"
          validate-on-blur
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md4 text-xs-center class="py-3">
        <v-btn
            small
            depressed
            color="primary background--text"
            @click="subscribeNewsletter"
          >
            {{$t("newsletter_form/submit_btn")}}
          </v-btn>
      </v-flex>
    </v-layout>
  </v-form>

</template>
<script>
import rules from "@/validation";

export default {
  name: "NewsletterForm",
  data() {
    return {
      form: {
        email: ""
      },
      rules,
    };
  },
  methods: {
    async subscribeNewsletter() {
      if (!this.$refs.NewsletterForm.validate()) {
          return false;
      }
      try {
        let response = await this.$store.dispatch("consumer/subscribeNewsletter", this.form);
        this.$store.dispatch("app/showMessage", {
          message: response,
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      } finally {
        this.form.email = ''
      }
    },
  },
};
</script>
